export enum enumEntrySummarySubStep {
  //Shipment Details
  SHIPMENT_DETAILS = 'SHIPMENT_DETAILS',
  FROM = 'FROM',
  TO = 'TO',
  VIA = 'VIA',

  //Bill of Lading Details
  MASTER_SCAC = 'MASTER_SCAC',
  MASTER_BL = 'MASTER_BL',
  HOUSE_SCAC = 'HOUSE_SCAC',
  HOUSE_BL = 'HOUSE_BL',
  QUANTITY = 'QUANTITY',
  IT = 'IT',

  //Seller, Consignee and Buyer Details
  SELLER_DETAILS = 'SELLER_DETAILS',
  CONSIGNEE_DETAILS = 'CONSIGNEE_DETAILS',
  BUYER_DETAILS = 'BUYER_DETAILS',

  //Shipping Terms of Sale
  SHIPPING_TERMS_OF_SALE = 'SHIPPING_TERMS_OF_SALE',

  //Invoice Main Details
  INVOICE_MAIN_DETAILS = 'INVOICE_MAIN_DETAILS',

  //Manufacturer Details
  MANUFACTURER_DETAILS = 'MANUFACTURER_DETAILS',

  //Line Item Details
  LINE_ITEM = 'LINE_ITEM',

  //Shipment Type Details
  SHIPMENT_TYPE = 'SHIPMENT_TYPE',
}
